import { defaultLanguage, useLanguage } from '@cloudflare/realtimekit-ui';
// Source pack for the dashboard/widget bundle. Keep public/video-meeting-locales/pt_BR.json
// as an identical copy so the static video-meeting.html page can fetch it in production.
import ptBR from './realtimeKitLocales/pt_BR.json';

const LOCALE_PACKS = {
  pt_BR: ptBR,
};

/**
 * Normalize Chatwoot locale codes to RealtimeKit pack keys.
 * pt / pt-BR / pt_BR → pt_BR; everything else falls back to English defaults.
 */
export const normalizeRealtimeKitLocale = locale => {
  if (!locale) return 'en';

  const normalized = String(locale).replace(/-/g, '_');
  if (normalized.toLowerCase().startsWith('pt')) return 'pt_BR';

  return normalized;
};

export const getRealtimeKitLanguage = locale => {
  const packKey = normalizeRealtimeKitLocale(locale);
  const overrides = LOCALE_PACKS[packKey];

  if (!overrides) {
    return useLanguage(defaultLanguage);
  }

  return useLanguage({ ...defaultLanguage, ...overrides });
};
